'use client';

import { UploadAssetsProvider } from '@/app/assets/contexts/UploadAssetsContext';
import { PropsWithChildren } from 'react';
import { AssetsLayoutWithSidebar } from '@/app/assets/details/AssetsLayoutWithSidebar';
import { EditedWorkflowsProvider } from '@/app/workflows/contexts/editedWorkflows';
import { SelectedAssetProvider } from './contexts/SelectedAssetContext';
import { RowSelectionProvider } from './contexts/RowSelectionContext';
import { RunWorkflowProvider } from '@/app/assets/contexts/RunWorkflowContext';

export default function AssetsLayout({ children }: PropsWithChildren) {
  return (
    <RowSelectionProvider>
      <EditedWorkflowsProvider>
        <SelectedAssetProvider>
          <UploadAssetsProvider>
            <RunWorkflowProvider>
              <AssetsLayoutWithSidebar>{children}</AssetsLayoutWithSidebar>
            </RunWorkflowProvider>
          </UploadAssetsProvider>
        </SelectedAssetProvider>
      </EditedWorkflowsProvider>
    </RowSelectionProvider>
  );
}
